import { Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { Layout } from './components/layout'
import { ErrorBoundary, PageErrorFallback } from './components/ui'

// Lazy load pages for code splitting
const Landing = lazy(() => import('./pages/Landing'))
const Talks = lazy(() => import('./pages/Talks'))
const Publications = lazy(() => import('./pages/Publications'))
const Contact = lazy(() => import('./pages/Contact'))
const Resume = lazy(() => import('./pages/Resume'))
const AllContent = lazy(() => import('./pages/AllContent'))
const NotFound = lazy(() => import('./pages/NotFound'))

// Loading fallback
const PageLoader = () => (
  <div className="flex h-screen items-center justify-center bg-gray-950">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--persona-primary)] border-t-transparent" />
  </div>
)

function App() {
  return (
    <>
      <Layout>
        <ErrorBoundary fallback={<PageErrorFallback />}>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {/* Landing page - Single page with all personas */}
              <Route path="/" element={<Landing />} />

              {/* Secondary pages */}
              <Route path="/talks" element={<Talks />} />
              <Route path="/publications" element={<Publications />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/all" element={<AllContent />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </Layout>

    </>
  )
}

export default App
